import React from 'react'
import { cn } from '@/lib/utils'

/**
 * McpRail (W10b) — the rail beneath (or beside) the AgentConsole: mono text chips
 * for the agents you can connect, plus an MCP badge.
 *
 * Every string is quoted VERBATIM from the copy doc's §W10 "MCP rail". Chips are
 * TEXT ONLY — no third-party logos or lookalike marks (trademark caution, per plan
 * §2.7 / claims-register §7). Renders inside the dark AI-native section, so it uses
 * the dark chip / label variants from marketing3.css by context.
 */

// Rail chips, in the copy doc's order.
const RAIL_CHIPS = ['Claude', 'Codex', 'your own']
const RAIL_BADGE = 'MCP'

export default function McpRail({ className }: { className?: string }) {
  return (
    <div
      className={cn('flex flex-wrap items-center gap-2.5', className)}
      role="img"
      aria-label="Connect Claude, Codex, or your own agent through MCP."
    >
      <span className="mkt3-label mr-0.5">Connect</span>

      {RAIL_CHIPS.map((chip) => (
        <span
          key={chip}
          className="mkt3-chip inline-flex items-center rounded-lg px-3 py-1.5 font-mono text-[11px] tracking-[0.02em]"
        >
          {chip}
        </span>
      ))}

      <span aria-hidden="true" className="mx-0.5 h-4 w-px bg-white/10" />

      {/* MCP badge — the connection standard, set apart from the agent chips */}
      <span className="inline-flex items-center gap-1.5 rounded-lg border border-teal-400/30 bg-teal-500/[0.08] px-3 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-teal-300">
        <span
          aria-hidden="true"
          className="mkt3-live-dot h-1 w-1 rounded-full bg-teal-400 shadow-[0_0_6px_rgba(45,212,191,0.9)]"
        />
        {RAIL_BADGE}
      </span>
    </div>
  )
}
